import angular from 'angular';
//import uiRouter from 'angular-ui-router';
import sicknessLeaveDateComponent from './sicknessLeaveDate.component';

let sicknessLeaveDateModule = angular.module('sicknessLeaveDate', [
  //uiRouter
])

.component('sicknessLeaveDate', sicknessLeaveDateComponent)

.name;

export default sicknessLeaveDateModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/sicknessLeaveDate/sicknessLeaveDate.js